module.exports = __webpack_public_path__ + "img/tom-everingham-cut-out.3ca8a51.jpg";